import React, { useEffect } from 'react';
import { Typography, Divider, Space, Layout } from 'antd';
import Footer from '../components/Footer';
import { getCurrentDestination } from '../services/destinationsService';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

function Privacy() {
  useEffect(() => {
    const setPageTitle = async () => {
      try {
        const destination = await getCurrentDestination();
        window.document.title = `Privacy Policy | ${destination.name}`;
      } catch (error) {
        window.document.title = 'Privacy Policy';
      }
    };

    setPageTitle();
  }, []);

  return (
    <Layout>
      <Content style={{ padding: '24px 50px', minHeight: 'calc(100vh - 64px)' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          <Title level={1}>Privacy Policy</Title>
          <Paragraph>Last updated: {new Date().toLocaleDateString()}</Paragraph>

          <Divider />

          <Title level={2}>Introduction</Title>
          <Paragraph>
            We respect your privacy and are committed to protecting your personal data. This privacy
            policy will inform you about how we look after your personal data when you visit our
            website and tell you about your privacy rights and how the law protects you.
          </Paragraph>

          <Title level={2}>The Data We Collect</Title>
          <Paragraph>
            We may collect, use, store and transfer different kinds of personal data about you which
            we have grouped together as follows:
          </Paragraph>
          <ul>
            <li>
              <Text strong>Identity Data</Text> includes first name, last name, username or similar
              identifier.
            </li>
            <li>
              <Text strong>Contact Data</Text> includes email address and telephone numbers.
            </li>
            <li>
              <Text strong>Technical Data</Text> includes internet protocol (IP) address, browser
              type and version, time zone setting and location, browser plug-in types and versions,
              operating system and platform, and other technology on the devices you use to access
              this website.
            </li>
            <li>
              <Text strong>Usage Data</Text> includes information about how you use our website and
              services.
            </li>
          </ul>

          <Title level={2}>How We Use Your Data</Title>
          <Paragraph>
            We will only use your personal data when the law allows us to. Most commonly, we will
            use your personal data in the following circumstances:
          </Paragraph>
          <ul>
            <li>
              To provide you with information about places, events, and tours in your selected
              destination.
            </li>
            <li>To improve our website and services based on your feedback and interactions.</li>
            <li>To respond to your inquiries or requests.</li>
            <li>
              To send you updates about new features or destinations when you have opted in to
              receive such communications.
            </li>
          </ul>

          <Title level={2}>Data Security</Title>
          <Paragraph>
            We have put in place appropriate security measures to prevent your personal data from
            being accidentally lost, used or accessed in an unauthorized way, altered or disclosed.
            In addition, we limit access to your personal data to those employees, agents,
            contractors and other third parties who have a business need to know.
          </Paragraph>

          <Title level={2}>Data Retention</Title>
          <Paragraph>
            We will only retain your personal data for as long as necessary to fulfill the purposes
            we collected it for, including for the purposes of satisfying any legal, accounting, or
            reporting requirements.
          </Paragraph>

          <Title level={2}>Your Legal Rights</Title>
          <Paragraph>
            Under certain circumstances, you have rights under data protection laws in relation to
            your personal data, including:
          </Paragraph>
          <ul>
            <li>The right to request access to your personal data.</li>
            <li>The right to request correction of your personal data.</li>
            <li>The right to request erasure of your personal data.</li>
            <li>The right to object to processing of your personal data.</li>
            <li>The right to request restriction of processing your personal data.</li>
            <li>The right to request transfer of your personal data.</li>
            <li>The right to withdraw consent.</li>
          </ul>

          <Title level={2}>Changes to This Privacy Policy</Title>
          <Paragraph>
            We may update our privacy policy from time to time. We will notify you of any changes by
            posting the new privacy policy on this page.
          </Paragraph>

          <Title level={2}>Contact Us</Title>
          <Paragraph>
            If you have any questions about this privacy policy or our privacy practices, please
            contact us at:
          </Paragraph>
          <Paragraph>
            <Text strong>Email:</Text> privacy@example.com
          </Paragraph>
          <Space style={{ marginBottom: 50 }} />
        </div>
      </Content>
      <Footer />
    </Layout>
  );
}

export default Privacy;
